export default "__VITE_ASSET__bHGfGNaR__"